<template>
  <div :class="classes">
    <wt-text>
        <span v-for="(name,index) in data" :key="index" class="nav" :style="isLastNav(index) && 'color:' + activeColor">
            {{name}}
            <slot v-if="!isLastNav(index)">
                <span class="nav">></span>
            </slot>
        </span>
    </wt-text>
  </div>
</template>

<script>
/**
 * 使用方式：<wt-nav-arrow :data="data"></wt-nav-arrow>
 * 通过插槽指定分隔符：<wt-nav-arrow :data="data">
 *           +++
 *           </wt-nav-arrow>
 *
 * params:
 * data:['电子设备','平板','ipad'],
 * activeColor:'指定最后一项的颜色'
 */
// 组件class前缀
const prefixCls = 'wt-nav-arrow'

export default {
  name: 'wt-nav-arrow',
  props: {
    data: {
      type: Array,
      required: true
    },
    activeColor: {
      type: String,
      default: 'green'
    }
  },
  methods: {
    isLastNav (index) {
      return index === this.data.length - 1
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  }
}
</script>

<style lang="less">
/* 组件库组件禁止使用 module */
.wt-nav-arrow {
    //width:max-content;
    overflow: auto;
    .nav {
        font-size: 0.25rem;
    }
    .icon {
        font-size: 0.7em;
    }
}
</style>
